import React from "react"
import styled from "styled-components"
import SVGIcon from "components/presenters/common/SVGIcon"
import Button from "components/presenters/button/Button"
import constants from "utils/constants"

export default function TutorialBanner() {
	return (
		<MainGuideButton to={"/motishop/tutorial"} fullwidth={1}>
			<LeftBlock>
				<LeftTxt>모티샵 이용방법</LeftTxt>
				<BagIconWrapper>
					<BagIcon
						src={`${constants.imagePath}/commerce/icon/motishop_tutorial_shopping_bag-82x66.png`}
					/>
				</BagIconWrapper>
			</LeftBlock>
			<RightBlock>
				<RightArrBtn>
					<ArrowWrapper>
						<SVGIcon name={"arrow"} fill={"white"} />
					</ArrowWrapper>
				</RightArrBtn>
			</RightBlock>
		</MainGuideButton>
	)
}
// motishop_tutorial_shopping_bag-82x66.jpg
const MainGuideButton = styled(Button)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: linear-gradient(90deg, #fa802d 0%, #ffb887 100%);
	border-radius: calc(100vw * (9 / 375));
	padding: calc(100vw * (12 / 375)) calc(100vw * (23 / 375)) calc(100vw * (14 / 375))
		calc(100vw * (23 / 375));
`
const LeftBlock = styled.div`
	display: flex;
	align-items: center;
`
const LeftTxt = styled.span`
	font-style: normal;
	font-weight: 700;
	font-size: calc(100vw * (20 / 375));
	line-height: calc(100vw * (24 / 375));
	color: #ffffff;
	margin-right: calc(100vw * (7 / 375));
`
const BagIconWrapper = styled.div`
	display: inline-block;
	width: calc(100vw * (41 / 375));
	height: calc(100vw * (33 / 375));
`
const BagIcon = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`
const RightBlock = styled.div``
const RightArrBtn = styled.div`
	display: flex;
	width: calc(100vw * (48 / 375));
	height: calc(100vw * (48 / 375));
	background: #ff9b57;
	border-radius: 100%;
	align-items: center;
	justify-content: center;
`
const ArrowWrapper = styled.div`
	width: calc(100vw * (8 / 375));
	height: calc(100vw * (14 / 375));
	color: white;
`
